import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Label, Popup } from 'semantic-ui-react';
import urls from '@/constants/urls';

const AiSearchInfoLabel = () => (
  <Popup
    position="right center"
    trigger={(
      <Label
        className="aridhia-ai-label"
        size="medium"
        color="blue"
        as="a"
        href={urls.SEARCH_HELP}
        rel="noopener noreferrer"
        target="_blank"
      >
        <Icon name="wizard" />
        <FormattedMessage id="search.info.vector_search.title" />
      </Label>
    )}
    content={<FormattedMessage id="search.info.vector_search.content" />}
  />
);

export default AiSearchInfoLabel;
